// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Sgwinter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='8' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/sgwinter/1.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>为什么去新加坡</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>多元化研学</div>
                                <div className={this.state.currentTab == 2 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>世界名校参访</div>
                                <div className={this.state.currentTab == 3 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(3)}>报名须知</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/2.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/3.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/4.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/5.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/6.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/7.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/8.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/9.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/10.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/11.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/12.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/13.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/14.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/15.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/16.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 2 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/17.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/18.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/19.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/20.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/21.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/22.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/23.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/24.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/25.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/26.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/27.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/28.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/29.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/30.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/31.jpg")} /></div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/32.jpg")} /></div>
                            </div>}
                            {this.state.currentTab == 3 && <div>
                                <div><LazyImage imgUrl={require("./assets/img/sgwinter/33.jpg")} /></div>
                            </div>}
                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Sgwinter);